const Faculty = () => {
    return (
        <div id="faculty" className="vision-card">

            <h3 className="table-section-heading">
                FACULTY & STAFFS
            </h3>

            <div className="table-section-wrap">
                <table className="table-section faculty-table">

                    <tbody>
                        <tr>
                            <td>TOTAL NUMBER OF TEACHERS (ALL CLASSES)</td>
                            <td>19</td>
                            <td>NUMBER OF PGTs</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF TGTs</td>
                            <td>6</td>
                            <td>NUMBER OF PRTs</td>
                            <td>12</td>
                        </tr>
                        <tr>
                            <td>TOTAL NUMBER OF TEACHERS (ALL CLASSES)</td>
                            <td>19</td>
                            <td>NUMBER OF PGTs</td>
                            <td>0</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF PETs</td>
                            <td>1</td>
                            <td>OTHER NON-TEACHING STAFF</td>
                            <td>15</td>
                        </tr>
                        <tr>
                            <td>NUMBER OF MANDATORY QUALIFIED TEACHERS</td>
                            <td>3</td>
                            <td>NUMBER OF TRAININGS ATTENDED BY TEACHERS SINCE LAST YEAR</td>
                            <td>0</td>
                        </tr>
                    </tbody>
                </table>

            </div>

        </div>

    );
};

export default Faculty;